import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

// Profile
import UserProfile from "@/pages/Dashboard/Users/UserProfile.vue";

// User Management
import ListUserPage from "@/pages/Dashboard/Users/UserManagement/ListUserPage.vue";


// Devices
import CreateDevice from "@/pages/Dashboard/Devices/Create/CreateDevice.vue";
import EditDevice from "@/pages/Dashboard/Devices/Edit/EditDevice.vue";

// Device Management
import ListDevicePage from "@/pages/Dashboard/Devices/DeviceManagement/ListDevicePage.vue";

// Report
import DownloadDevice from "@/pages/Dashboard/Reports/Downloads/Downloads.vue";

// Pages
import Login from "@/pages/Dashboard/Pages/Login.vue";

// Components pages

// TableList pages

// Maps pages

//import middleware
import auth from "@/middleware/auth";
import guest from "@/middleware/guest";

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/notification",
  name: "Components",
  children: []
};

let profileMenu = {
  path: "/profiles",
  component: DashboardLayout,
  name: "Profiles",
  children: [
    {
      path: "user-profile",
      name: "User Profile",
      components: { default: UserProfile },
      meta: { middleware: auth, model: 'User'}
    },
    {
      path: "user-management/list-users",
      name: "List Users",
      components: { default: ListUserPage },
      meta: { middleware: auth, model: 'User' }
    }
  ]
};

let deviceMenu = {
  path: "/devices",
  component: DashboardLayout,
  name: "Devices",
  children: [
    {
      path: "create-device",
      name: "Create Device",
      components: { default: CreateDevice },
      meta: { middleware: auth, model: 'Device'}
    },
    {
      path: "edit-device/device/:deviceId",
      name: "Edit Device",
      components: { default: EditDevice },
      meta: { middleware: auth, model: 'Device'}
    },
    {
      path: "device-management/list-devices",
      name: "List Devices",
      components: { default: ListDevicePage },
      meta: { middleware: auth, model: 'Device' }
    },
  ]
};

let reportMenu = {
  path: "/reports",
  component: DashboardLayout,
  name: "Reports",
  children: [
    {
      path: "downloads",
      name: "Download",
      components: { default: DownloadDevice },
      meta: { middleware: auth, model: 'Download'}
    },
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { middleware: guest }
    },
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/device-management/list-devices",
    name: "List Devices"
  },
  {
    path: "/",
    component: DashboardLayout,
    meta: { middleware: auth },
    children: [
      {
        path: "device-management/list-devices",
        name: "List Devices",
        components: { default: ListDevicePage },
        meta: { middleware: auth }
      }
    ]
  },
  profileMenu,
  deviceMenu,
  reportMenu,
  componentsMenu,
  authPages
];

export default routes;
